import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const PostAdPost = async (payload: IAddAdPost) => {
  const {data} = await request.post(`/api/v2/market/farmer-post`, payload);
  return data;
};
export const PostMarketPost = async (payload: IAddAdPostFarm) => {
  const {data} = await request.post(`/api/v2/market/post`, payload);
  return data;
};
export const PostADEdit = async (payload: IAddAdPostFarmEdit) => {
  const {data} = await request.put(`/api/v2/market/post`, payload);
  return data;
};

export const PostEditDetail = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IPostEditDetail} = await request.get(
    `/api/v2/market/post-edit-detail?guid=${ctx.queryKey[1]}`,
  );
  return data;
};
